import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-loading-screen',
  templateUrl: './loading-screen.component.html',
  styleUrls: ['./loading-screen.component.css']
})
export class LoadingScreenComponent implements OnInit {

  constructor(private router: Router) {}

  ngOnInit(): void {
    // Wait for 2 seconds before redirecting
    setTimeout(() => {
      this.router.navigate(['/home']);
    }, 1000); // Change to 1000 for 1 second
  }
}
